import React, { useEffect, useState } from "react";
import {
  Image,
  Platform,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  BackHandler,
} from "react-native";
import { useFocusEffect } from "@react-navigation/native";
import { ActivityIndicator } from "react-native";

import { StackActions } from "@react-navigation/native";
import BackgroundAdmin from "../components/BackgroundAdmin";
import Title from "../components/Title";
import Logo from "../components/Logo";
import ButtonLayoutMenu from "../components/ButtonLayoutMenu";
import ButtonLayout from "../components/ButtonLayout";

import makeRequest from "../components/makeRequest";

const estilizarFecha = (fecha) => {
  fecha = new Date(fecha);
  return (
    (fecha.getDate() < 10 ? "0" + fecha.getDate() : fecha.getDate()) +
    "/" +
    (fecha.getMonth() + 1 < 10
      ? "0" + (fecha.getMonth() + 1)
      : fecha.getMonth() + 1) +
    "/" +
    fecha.getFullYear()
  );
};

export default function (props) {
  const [periodos, setPeriodos] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [deleted, setDelete] = useState(false);

  useEffect(() => {
    const getPeriodos = async () => {
      const req = await makeRequest("periodos", "get");
      if (req[0] == 200) {
        setPeriodos(
          req[1].filter(
            (e) => e.instalacion_id == props.route.params.instalaciones._id
          )
        );
        setLoaded(true);
      }
    };
    getPeriodos();
  }, [props.route.params.reload]);
  return (
    <BackgroundAdmin scroll={true}>
      <Logo navigation={props.navigation}></Logo>
      <View>
        <Title style={{ fontFamily: "Montserrat-Bold" }}>
          Seleccione un periodo
        </Title>
        {loaded ? (
          <>
            {periodos.map((e) => (
              <ButtonLayoutMenu
                key={e._id}
                text={
                  estilizarFecha(e.inicio) + " al " + estilizarFecha(e.final)
                }
                onPress={() =>
                  props.navigation.navigate("AnadirHorarios", {
                    delete: deleted,
                    instalacion: props.route.params.instalaciones,
                    _id: e._id,
                    fechaInicio: e.inicio,
                    fechaFinal: e.final,
                  })
                }></ButtonLayoutMenu>
            ))}
            {periodos.length == 0 && (
              <Title
                style={{
                  fontFamily: "Montserrat-Regular",
                  padding: 20,
                  fontSize: 15,
                }}>
                Todavía no ha añadido ningún periodo
              </Title>
            )}
          </>
        ) : (
          <ActivityIndicator
            size='large'
            color='rgba(255,255,255, 0.6)'
            style={{ marginTop: 5 }}
          />
        )}
        <ButtonLayout
          text='Añadir periodo'
          onPress={() =>
            props.navigation.navigate("AnadirPeriodo", {
              ...props.route.params,
              periodos,
            })
          }
        />
      </View>
    </BackgroundAdmin>
  );
}
